/**
 * ReferralAPI.js
 *
 * Indique e ganhe (public/api/referral/). Separado do API.js principal, no mesmo
 * molde de AdminAPI.js.
 */

import { getAccessToken } from './authTokens';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://www.gabriela.app.br/api/';

const REFERRAL_SUMMARY  = BASE_URL + 'referral/summary.php';
const REFERRAL_INDICATE = BASE_URL + 'referral/indicate.php';
const REFERRAL_LOOKUP   = BASE_URL + 'referral/lookup.php';

const call = (url, options, callback) => {
    fetch(url, options)
        .then(res => res.json())
        .then(data => callback(data))
        .catch(err => callback({ success: false, error: err.message || 'Erro de conexão' }));
};

const authHeaders = () => ({
    'Authorization': `Bearer ${getAccessToken()}`,
    'Content-Type': 'application/json',
});

/**
 * Código, link, contagens e lista de indicações da conta.
 * @param {Function} callback recebe { success, code, counts, referrals, daily_limit }
 */
export const GetReferralSummaryAPI = (callback) => {
    call(REFERRAL_SUMMARY, { method: 'GET', headers: authHeaders() }, callback);
};

/**
 * Indicação direta de um colega (vira contato da Prospecção, a equipe da Gabriela faz o contato).
 * @param {{ name: string, whatsapp: string, category?: string }} payload
 * A resposta é a mesma quando o número já é conhecido: a tela nunca revela quem é cliente.
 * @param {Function} callback recebe { success, status: 'registered' } ou { success: false, error }
 */
export const IndicateColleagueAPI = (payload, callback) => {
    call(REFERRAL_INDICATE, { method: 'POST', headers: authHeaders(), body: JSON.stringify(payload) }, callback);
};

/**
 * Quem é o dono de um código (público, usado pela landing ao abrir /i/CODIGO).
 * @param {string} code
 * @param {Function} callback recebe { success, company: { name } } ou { success: false }
 */
export const LookupReferralCodeAPI = (code, callback) => {
    call(REFERRAL_LOOKUP, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
    }, callback);
};
